<ng-container [ngSwitch]="optionType">
    <ng-container *ngSwitchCase="optionTypesEnum.Radio">
        <div class="options-list-entry" *ngFor="let option of options; let i = index" (click)="onOptionSelected(i)">
            <div class="form-check">
                <div class="responsive-flex-wrapper">
                    <label class="form-check-label">
                        <input type="radio" class="form-check-input" [checked]="isSelected(option)" [name]="inputName"/>
                        <i class="input-helper"></i>
                    </label>
                </div>
            </div>
            <div *ngIf="translate != 1" class="options-list-entry-text" style="line-height: 100% !important;">
               <p *ngIf="hasText(option)" style="
                    margin: 0;
                    padding: 0;
                    font-size: 0.95rem;
                    font-weight: bold;
                    text-transform: uppercase;
                    margin-bottom: -11px;">{{ getOptionText(option) }}</p>
               <p *ngIf="hasText(option)" style="margin: 0; padding: 0; margin-top: 9px;">{{ getOptionBindText(option) }}</p>
                <p *ngIf="!hasText(option)" style="margin: 0; padding: 0; margin-bottom: -9px;">{{ getOptionText(option) }}</p>
            </div>
            <div *ngIf="translate == 1" class="options-list-entry-text">{{ getOptionText(option) | localise }}</div>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="optionTypesEnum.Checkbox">
        <div class="options-list-entry" *ngFor="let option of options; let i = index" (click)="onOptionSelected(i)">
            <div class="form-check">
                <div class="responsive-flex-wrapper">
                    <label class="form-check-label">
                        <input type="checkbox" class="form-check-input" [checked]="isSelected(option)"
                               [name]="inputName"/>
                        <i class="input-helper"></i>
                    </label>
                </div>
            </div>
            <div *ngIf="translate != 1" class="options-list-entry-text">{{ getOptionText(option) }}</div>
            <div *ngIf="translate == 1" class="options-list-entry-text">{{ getOptionText(option) | localise }}</div>
        </div>
    </ng-container>
    <ng-container *ngSwitchDefault></ng-container>
</ng-container>
